import React, { useEffect, useState } from "react";
import moment from "moment";

import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";

import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DeleteIcon from "@material-ui/icons/Delete";
import CloseIcon from '@material-ui/icons/Close';

import { userStyles } from "./Styles/PlolygonServicesPageStyles";
import { POLYGON_CONSTANT_TEXT } from "./Utils/PlolygonServicesConstants";
import { createCamelCase } from "../../utils/helperFunctions";
import { ChangeConfigOtion } from "../common/App/AppViewUtils";
import { ALERT_TYPES, ALL_DAYS_VALUES, API_RESPONSE_STATUS, APP_ROUTES } from "../../config/constants";
import { _design_Pos_Zone_Service_List_Record } from "../DeliveryFee/Utils/DeliveryFeeUtils";
import { countObjectProperties, isArrayValid, isEmptyOrNull, isNonEmptyObject, isUndefined } from "utils/DataUtils";
import { AppStateObj, AppStateObjInterface, MappingListInterface, MappingListItem, MappingListPosZoneArray, ServiceTypeRecord } from "./Utils/PlolygonServicesInterface";
import { serviceSelectPropositionRecord } from "../../config/redux/configurationsSlice";

import * as PlolygonServicesSlice from "./Redux/PlolygonServicesSlice";
import * as PlolygonServicesUtils from "./Utils/PlolygonServicesUtils";
import * as PlolygonServicesConstants from "./Utils/PlolygonServicesConstants";

import TimePicker from "../common/TimePicker/TimePicker";
import PosZoneMappingDialog from "./PosZoneMappingDialog/PosZoneMappingDialog";
import CustomAlert from "../common/CustomAlert/CustomAlert";
import OverlayLoader from "../common/Loader/OverlayLoader";
import RenderPolygonIdsMapping from "./Common/RenderPolygonIdsMapping";
import PrimaryButton from "components/common/PrimaryButton/PrimaryButton";
import RenderPolygonDetailsPopUp from "./Common/RenderPolygonDetailsPopUp";
import { selectUserDetails } from "../Login/redux/userSlice";
import MultiSelectBox from "../common/MultiSelectBox/MultiSelectBox";
import LinkButton from "components/common/LinkButton/LinkButton";
import produce from "immer";

const PlolygonServicesConfigurationPage = () => {
  const classes = userStyles();
  let location = useLocation();
  const navigate = useNavigate();
  const appDispatch = useDispatch();

  const userInfo: any = useSelector(selectUserDetails);
  const { currentCountry } = useSelector((state: any) => state.appConfig);
  const posZoneMapListService: any = useSelector(PlolygonServicesSlice.selectServiceTypePosZoneMapRecord);
  const allPolygonListIdsRecord: any = useSelector(PlolygonServicesSlice.selectAllIdsPolygonRecord);
  const servicePropositionList = useSelector(serviceSelectPropositionRecord);

  const [appStateObj, setAppStateObj] = useState<AppStateObjInterface>(AppStateObj);

  const existingConfigChangeHandler = (event: any, recordListIndex: number, name: "sameAsEarlier") => {
    if (!isEmptyOrNull(event?.target?.checked)) {
      const { checked } = event.target;
      setAppStateObj(prevState => {
        return produce(prevState, draft => {
          const targetServiceRecord = draft.serviceTypeRecordList[recordListIndex];
          targetServiceRecord[name] = checked;
          targetServiceRecord.active = !checked;

          if (!checked) {
            targetServiceRecord.openAccordian = !checked;
          }

          targetServiceRecord.mappingList = [
            {
              days: [...ALL_DAYS_VALUES],
              mappings: [
                {
                  startTime: new Date().setHours(0, 0, 0),
                  endTime: new Date().setHours(23, 59, 59),
                  isNonServiceable: null
                }
              ]
            }
          ];
        });
      });
    }
  };

  const configChangeExistingHandler = (event: any, recordListIndex: number, name: "enableConfigEdit") => {
    setAppStateObj(prevState => {
      return produce(prevState, draft => {
        const targetServiceRecord = draft.serviceTypeRecordList[recordListIndex];
        targetServiceRecord[name] = !targetServiceRecord[name];
      });
    });
  };

  const handleServiceTypeAccordionOpenState = (event: any, recordListIndex: number) => {
    event.stopPropagation();
    setAppStateObj(prevState => {
      return produce(prevState, draft => {
        const serviceTypeRecordList = draft.serviceTypeRecordList;
        const updatedServiceTypeRecord = {
          ...serviceTypeRecordList[recordListIndex],
          openAccordian: !serviceTypeRecordList[recordListIndex].openAccordian,
        };
        serviceTypeRecordList[recordListIndex] = updatedServiceTypeRecord;
      });
    });
  };

  const handleAddMappingButton = (recordListIndex: number, mappingObjIndex: number) => {
    const serviceTypeRecordList = [...appStateObj.serviceTypeRecordList];
    const updatedServiceTypeRecord = { ...serviceTypeRecordList[recordListIndex] };
    const updatedMappingList = [...updatedServiceTypeRecord.mappingList];
    const selectedMappingRecord = updatedMappingList[mappingObjIndex]?.mappings || [];

    let issueFound: boolean = false;
    let endFound: boolean = false;

    // Check if existing time ranges exceed 24 hours
    const existingTimeDifference = selectedMappingRecord.reduce((acc, mapping) => {
      if (mapping.startTime && mapping.endTime && moment(mapping.startTime).isValid() && moment(mapping.endTime).isValid()) {
        if (moment(mapping.endTime).hours() === 23 && moment(mapping.endTime).minutes() === 59) {
          endFound = true;
        }
        return acc + (Number(mapping.endTime) - Number(mapping.startTime));
      } else {
        issueFound = true;
        CustomAlert(ALERT_TYPES.ERROR, PlolygonServicesConstants.POLYGON_CONSTANT_TEXT.PROVIDE_VALID_START_END_TIME);
        return acc; // Return accumulated time even if some mappings have invalid times
      }
    }, 0);

    if (issueFound) {
      CustomAlert(ALERT_TYPES.ERROR, PlolygonServicesConstants.POLYGON_CONSTANT_TEXT.PROVIDE_VALID_START_END_TIME);
    } else {
      // Allow a small buffer to account for potential rounding errors
      const allowedTolerance = 1000; // 1 second in milliseconds
      if (endFound || existingTimeDifference + allowedTolerance >= PlolygonServicesConstants.ONE_DAY_IN_MILLI_SECONDS) {
        CustomAlert(ALERT_TYPES.ERROR, PlolygonServicesConstants.POLYGON_CONSTANT_TEXT.TIME_RANGE_ISSUE_ADD_MAPPING);
        return;
      }

      if (!issueFound) {
        const lastEndTime = selectedMappingRecord[selectedMappingRecord.length - 1]?.endTime ?? undefined;
        const newMapping = {
          startTime: lastEndTime || new Date().setHours(0, 0, 0),
          endTime: new Date().setHours(23, 59, 59),
          isNonServiceable: null
        };
        setAppStateObj(prevState => {
          return produce(prevState, draft => {
            draft.serviceTypeRecordList[recordListIndex].mappingList[mappingObjIndex]?.mappings.push(newMapping);
          });
        });
      }
    }
  };

  const handleRemoveMappingButton = (recordListIndex: number, mappingListIndex: number, mappingsIndex: number) => {
    setAppStateObj(prevState => {
      return produce(prevState, draft => {
        draft.serviceTypeRecordList[recordListIndex].mappingList[mappingListIndex].mappings.splice(mappingsIndex, 1);
      });
    });
  };

  const handleServiceTimeChange = (mappingsIndex: number, mappingObjIndex: number, serviceObjIndex: number, name: "startTime" | "endTime", date: any) => {
    setAppStateObj(prevState => {
      let dateCopy: any = date;
      if (name === "endTime" && moment(date).isValid() && date?.getHours() === 23 && date?.getMinutes() === 59) {
        dateCopy.setSeconds(59);
      }

      return produce(prevState, draft => {
        const targetMappingItem = draft.serviceTypeRecordList[serviceObjIndex]
          .mappingList[mappingObjIndex]
          .mappings[mappingsIndex];

        targetMappingItem[name] = dateCopy;

        if (isArrayValid(targetMappingItem?.posZoneMappingArray)) {
          targetMappingItem?.posZoneMappingArray?.forEach(posZoneMappingObj => {
            posZoneMappingObj[name] = dateCopy;
          });
        }
      });
    });
  };

  const handleOpenPosZoneMappingDialog = (serviceName: string, serviceRowIndex: number, mappingListRowIndex: number, mappingItemIndex: number) => {
    if (!isEmptyOrNull(serviceName)) {
      let serviceTypeList = [];
      serviceTypeList.push(serviceName.toUpperCase());
      let newAppStateObj = PlolygonServicesUtils.handle_reset_pos_zone_mappind_details_utils(appStateObj, true, serviceName, serviceRowIndex, mappingListRowIndex, mappingItemIndex);
      setAppStateObj(newAppStateObj);
      appDispatch(PlolygonServicesSlice.fetchPosZoneServiceTypeListByCountryIdAndServiceType({ countryId: currentCountry.countryId, pageSize: 1000, pageNumber: 0, serviceType: [...serviceTypeList] }));
    }
  };

  const handleClosePosZoneMappingDialog = () => {
    appDispatch(PlolygonServicesSlice.resetPosZoneListDetailsServiceState());
    let newAppStateObj = PlolygonServicesUtils.handle_reset_pos_zone_mappind_details_utils(appStateObj, false, "", "", "", "");
    setAppStateObj(newAppStateObj);
  };

  const fetchRecordsByPosCode = () => {
    if (!isEmptyOrNull(appStateObj?.posZoneSearchText)) {
      let newAppStateObj = PlolygonServicesUtils.design_custom_pos_zone_mapping_filtered_list_based_on_search(appStateObj, appStateObj.posZoneSearchText);
      setAppStateObj(newAppStateObj);
    }
  };

  const handleKeyUp = (e: any) => {
    if (!isEmptyOrNull(e?.key)) {
      if (e.key === "Enter" || e.keyCode === 13) {
        fetchRecordsByPosCode();
      }
    }
  };

  const configurePosZoneDataError = () => {
    if (!isEmptyOrNull(posZoneMapListService?.error)) {
      let newAppStateObj = PlolygonServicesUtils._handle_empty_pos_zone_mapping_data_and_loading_off(appStateObj);
      setAppStateObj(newAppStateObj);
    }
  };

  const configurePosZoneData = () => {
    if (
      Array.isArray(posZoneMapListService?.data) &&
      posZoneMapListService?.fetchStatus === API_RESPONSE_STATUS.SUCCEEDED
    ) {
      const { listData }: any = _design_Pos_Zone_Service_List_Record(posZoneMapListService.data);
      let newAppStateObj = PlolygonServicesUtils._handle_Pos_Zone_Service_List_Record(appStateObj, listData);
      setAppStateObj(newAppStateObj);
    }
  };

  const handlePosZoneSearchChange = (event: any) => {
    if (!isEmptyOrNull(event?.target)) {
      let { value } = event.target;
      let newAppStateObj = PlolygonServicesUtils.design_custom_pos_zone_mapping_filtered_list_based_on_search(appStateObj, value);
      setAppStateObj(newAppStateObj);
    }
  };

  const updatePosNumberOpenIndex = (pos_list_id: any, pos_list_index: any) => {
    if (!isEmptyOrNull(pos_list_id)) {
      let newAppStateObj = PlolygonServicesUtils._handle_action_pos_zone_mapping_open_index_utils(appStateObj, pos_list_id, pos_list_index);
      setAppStateObj(newAppStateObj);
    }
  };

  const handleChangeIsNonServiceable = () => {
    setAppStateObj({ ...appStateObj, isNonServiceable: !appStateObj.isNonServiceable, selectedPosZoneIndex: "", selectedPosZoneObj: {} });
  };

  const selectPosZoneForMapping = (pos_list_id: any, pos_list_index: any, pos_zone_id: any, pos_zone_Index: any) => {
    if (!isEmptyOrNull(pos_list_id) && !isEmptyOrNull(pos_zone_id)) {
      let newAppStateObj = PlolygonServicesUtils._handle_action_pos_zone_selected_mapping_obj_utils(appStateObj, pos_list_id, pos_list_index, pos_zone_id, pos_zone_Index);
      setAppStateObj(newAppStateObj);
    }
  };

  const designPolygonSubmitObject = () => {
    const { serviceTypeName, serviceRowIndex, mappingListRowIndex, mappingItemIndex, serviceTypeRecordList, selectedPosZoneObj, isNonServiceable } = appStateObj;

    if (!serviceTypeName || serviceRowIndex === undefined || mappingListRowIndex === undefined) {
      CustomAlert(ALERT_TYPES.ERROR, PlolygonServicesConstants.NO_POS_ZONE_SELECTED_ERROR);
      setAppStateObj({ ...appStateObj, loading: false });
      return;
    }

    const currentServiceRecord = serviceTypeRecordList[Number(serviceRowIndex)];
    const targetMapping = currentServiceRecord?.mappingList?.[Number(mappingListRowIndex)]?.mappings?.[Number(mappingItemIndex)];

    if (isEmptyOrNull(targetMapping)) {
      CustomAlert(ALERT_TYPES.ERROR, PlolygonServicesConstants.NO_POS_ZONE_SELECTED_ERROR);
      setAppStateObj({ ...appStateObj, loading: false });
      return;
    }
    let updatedMappingItem: MappingListItem = { ...targetMapping };

    const isMultipleConfigurationAllowed = getIsMultipleConfigurationAllowed(currentServiceRecord);
    if (isNonServiceable) {
      updatedMappingItem = {
        ...targetMapping,
        isNonServiceable: true,
        posZoneMappingArray: []
      };
    } else if (isMultipleConfigurationAllowed) {
      const newPosZoneMapping: MappingListPosZoneArray = {
        ...selectedPosZoneObj,
        isNonServiceable: false, // Ensure individual mapping in array is serviceable
        startTime: targetMapping.startTime,
        endTime: targetMapping.endTime,
      };
      const existingPosZoneMappings = targetMapping.posZoneMappingArray || [];
      const isDuplicate = existingPosZoneMappings.some(
        (item) => item?.posNo?.toString() === newPosZoneMapping?.posNo?.toString() && item?.zoneId?.toString() === newPosZoneMapping?.zoneId?.toString()
      );
      if (isDuplicate) {
        CustomAlert(ALERT_TYPES.ERROR, 'This POS Zone is already mapped for this configuration.');
        setAppStateObj({ ...appStateObj, loading: false }); // Stop loading and return
        return;
      }
      const shouldReplaceArray = existingPosZoneMappings?.length === 1 && isEmptyOrNull(existingPosZoneMappings[0]?.posNo);
      const newPosZoneMappingArray = shouldReplaceArray
        ? [newPosZoneMapping] // Replace with just the new one
        : [...existingPosZoneMappings, newPosZoneMapping];
      updatedMappingItem = {
        ...targetMapping,
        isNonServiceable: false, // Explicitly setting this to false
        posZoneMappingArray: newPosZoneMappingArray, // Assign the newly constructed array
      };
    } else {
      updatedMappingItem = {
        ...targetMapping,
        ...selectedPosZoneObj,
        isNonServiceable: false,
        posZoneMappingArray: undefined  // Explicitly remove array for single configuration
      };
    }

    const updatedMappings = currentServiceRecord.mappingList[Number(mappingListRowIndex)].mappings.map(
      (item, index) => (index === Number(mappingItemIndex) ? updatedMappingItem : item)
    );

    let newAppStateObj = PlolygonServicesUtils.hanlde_update_service_type_record(
      appStateObj,
      false, // loading: false
      appStateObj.serviceRowIndex,
      appStateObj.mappingListRowIndex,
      updatedMappings
    );
    setAppStateObj(newAppStateObj);
  };

  const handlePOSZoneMappingSubmit = () => {
    setAppStateObj({ ...appStateObj, loading: true });
    if (appStateObj.isNonServiceable || countObjectProperties(appStateObj?.selectedPosZoneObj) > 0) {
      designPolygonSubmitObject();
    } else {
      CustomAlert(ALERT_TYPES.ERROR, PlolygonServicesConstants.NO_POS_ZONE_SELECTED_ERROR);
      setAppStateObj({ ...appStateObj, loading: false });
    }
  };

  const getAllPolygonRecords = () => {
    setAppStateObj({
      ...appStateObj,
      loading: true,
      isEditMode: false,
      polygonId: null,
      polygonIdsSearchTextValue: "",
      allPolygonListIdsRecord: [],
      mappedPolygonIdsSearchTextValue: "",
      mappedPolygonIdsRecord: [],
    });
    appDispatch(PlolygonServicesSlice.getAllPolygonIdsDetails());
  };

  const configurePolygonIdsRecordError = () => {
    CustomAlert(ALERT_TYPES.ERROR, allPolygonListIdsRecord.error);
    setAppStateObj({ ...appStateObj, loading: false, serviceTypeRecordList: PlolygonServicesUtils.getServiceTypeRecordList(servicePropositionList, userInfo) });
  };

  const configurePolygonIdsRecord = () => {
    setAppStateObj({
      ...appStateObj,
      loading: false,
      polygonIdsSearchTextValue: "",
      allPolygonListIdsRecord: allPolygonListIdsRecord.data,
      mappedPolygonIdsSearchTextValue: "",
      mappedPolygonIdsRecord: [],
      serviceTypeRecordList: PlolygonServicesUtils.getServiceTypeRecordList(servicePropositionList, userInfo),
    });
  };

  const handleClosePolygonDetailsPopUp = () => {
    setAppStateObj({ ...appStateObj, openPolygonDetailsPopUp: false, polygonDetailsPopUpData: {} });
  };

  const fetchPolygonIdDetails = async (polygonId: string) => {
    const { payload }: any = await appDispatch(PlolygonServicesSlice.fetchPolygonIdDetails(polygonId));
    if (payload?.polygonId !== undefined) {
      handlePolygonClickForDetailsPopUp(payload.polygonId, PlolygonServicesUtils.designServiceTypeRecordListUtils(payload, servicePropositionList, userInfo));
    } else {
      setAppStateObj({ ...appStateObj, loading: false, openPolygonDetailsPopUp: false, polygonDetailsPopUpData: {} });
      let errorMessage = POLYGON_CONSTANT_TEXT.ERROR_FETCHING_CONFIG;
      if (payload.message && payload.message !== POLYGON_CONSTANT_TEXT.NO_MESSAGE_AVAILABLE) {
        errorMessage = payload.message;
      }
      CustomAlert(ALERT_TYPES.ERROR, errorMessage);
    }
  };

  const handlePolygonClickForDetailsPopUp = (polygonId: string, polygonDetailsPopUpData: ServiceTypeRecord[]) => {
    setAppStateObj({ ...appStateObj, openPolygonDetailsPopUp: true, polygonDetailsPopUpData: { polygonId, serviceTypeRecordList: polygonDetailsPopUpData }, loading: false });
  };

  const getPolygonDetails = (polygonId: string) => {
    if (!isEmptyOrNull(polygonId)) {
      setAppStateObj({ ...appStateObj, loading: false });
      fetchPolygonIdDetails(polygonId);
    } else {
      CustomAlert(ALERT_TYPES.ERROR, POLYGON_CONSTANT_TEXT.NO_POLYGON_ID_FOUND);
    }
  };

  const headerPolygonIdsRowCheckboxOnchange = (event: any) => {
    if (!isEmptyOrNull(event?.target)) {
      const { checked } = event.target;
      let newAppStateObj = PlolygonServicesUtils.headerPolygonIdsRowCheckboxOnchangeUtils(appStateObj, checked);
      setAppStateObj(newAppStateObj);
    }
  };

  const tableRowCellCheckboxOnchange = (event: any, polygonId: string) => {
    if (!isEmptyOrNull(event?.target)) {
      const { checked } = event.target;
      let newAppStateObj = PlolygonServicesUtils.tableRowCellCheckboxOnchangeUtils(appStateObj, checked, polygonId);
      setAppStateObj(newAppStateObj);
    }
  };

  const deleteSelectedMappedPolygonId = (event: any, polygonId: string) => {
    if (!isEmptyOrNull(polygonId)) {
      let newAppStateObj = PlolygonServicesUtils.deleteSelectedMappedPolygonIdUtils(appStateObj, polygonId);
      setAppStateObj(newAppStateObj);
    }
  };

  const handlePolygonIdSearchTextChange = (event: any) => {
    if (!isEmptyOrNull(event?.target)) {
      let { name, value } = event.target;
      if (name === "polygonIdsSearchTextValue") {
        let newAppStateObj = PlolygonServicesUtils.handlePolygonIdSearchTextChangeUtils(appStateObj, allPolygonListIdsRecord?.data || [], value);
        setAppStateObj(newAppStateObj);
      }
    }
  };

  const handleMappedPolygonIdSearchTextChange = (event: any) => {
    if (!isEmptyOrNull(event?.target)) {
      let { name, value } = event.target;
      if (name === "mappedPolygonIdsSearchTextValue") {
        let newAppStateObj = PlolygonServicesUtils.handleMappedPolygonIdSearchTextChangeUtils(appStateObj, value);
        setAppStateObj(newAppStateObj);
      }
    }
  };

  const getPolygonIdsRecordList = () => {
    let assigned_list_data = PlolygonServicesUtils.getPolygonIdsRecordListUtils(appStateObj, allPolygonListIdsRecord?.data || []);
    return [...new Set(assigned_list_data)];
  };

  const getMappedPolygonIdsRecordList = () => {
    let assigned_list_data = PlolygonServicesUtils.getMappedPolygonIdsRecordListUtils(appStateObj);
    return [...new Set(assigned_list_data)];
  };

  // handlePolygonConfigurationSave
  const saveNewPolygonIdConfig = async (payloadOject: any) => {
    const { payload }: any = await appDispatch(PlolygonServicesSlice.createNewPolygonIdConfig(payloadOject));
    if (payload?.message !== undefined) {
      setAppStateObj({ ...appStateObj, loading: false });
      let errorMessage = POLYGON_CONSTANT_TEXT.ERROR_CREATE_CONFIG;
      if (payload.message && payload.message !== POLYGON_CONSTANT_TEXT.NO_MESSAGE_AVAILABLE) {
        errorMessage = payload.message;
      }
      CustomAlert(ALERT_TYPES.ERROR, errorMessage);
    } else if (payload) {
      CustomAlert(ALERT_TYPES.SUCCESS, `Polygon mappings updated successfully`);
      navigate(APP_ROUTES.POLYGON_SERVICES);
    }
  };

  const updateNewPolygonIdConfig = async (payloadOject: any) => {
    const { payload }: any = await appDispatch(PlolygonServicesSlice.updatePolygonIdConfig(payloadOject));
    if (payload?.message !== undefined) {
      setAppStateObj({ ...appStateObj, loading: false });
      let errorMessage = POLYGON_CONSTANT_TEXT.ERROR_CREATE_CONFIG;
      if (payload.message && payload.message !== POLYGON_CONSTANT_TEXT.NO_MESSAGE_AVAILABLE) {
        errorMessage = payload.message;
      }
      CustomAlert(ALERT_TYPES.ERROR, errorMessage);
    } else if (payload) {
      CustomAlert(ALERT_TYPES.SUCCESS, `Polygon mapping updated successfully`);
      navigate(APP_ROUTES.POLYGON_SERVICES);
    }
  };

  const handlePolygonConfigurationSave = () => {
    const payloadOject = PlolygonServicesUtils.validatePolygonIdConfigurationSaveObject(appStateObj, POLYGON_CONSTANT_TEXT.SAVE, servicePropositionList);
    if (isNonEmptyObject(payloadOject)) {
      setAppStateObj({ ...appStateObj, loading: false });
      saveNewPolygonIdConfig(payloadOject);
    }
  };

  const handlePolygonConfigurationUpdate = () => {
    const payloadOject = PlolygonServicesUtils.validatePolygonIdConfigurationSaveObject(appStateObj, POLYGON_CONSTANT_TEXT.UPDATE, servicePropositionList);
    if (isNonEmptyObject(payloadOject)) {
      setAppStateObj({ ...appStateObj, loading: false });
      updateNewPolygonIdConfig(payloadOject);
    }
  };

  const getPolygonIdDetails = async (polygonId: string) => {
    setAppStateObj({ ...appStateObj, loading: true, isEditMode: true });
    const { payload }: any = await appDispatch(PlolygonServicesSlice.fetchPolygonIdDetails(polygonId));
    if (payload?.polygonId !== undefined) {
      setAppStateObj({
        ...appStateObj,
        loading: false,
        isEditMode: true,
        polygonId: payload.polygonId,
        serviceTypeRecordList: PlolygonServicesUtils.designServiceTypeRecordListUtils(payload, servicePropositionList, userInfo)
      });
    } else {
      setAppStateObj({ ...appStateObj, loading: false });
      let errorMessage = POLYGON_CONSTANT_TEXT.ERROR_FETCHING_CONFIG;
      if (payload.message && payload.message !== POLYGON_CONSTANT_TEXT.NO_MESSAGE_AVAILABLE) {
        errorMessage = payload.message;
      }
      CustomAlert(ALERT_TYPES.ERROR, errorMessage);
    }
  };

  const isDisabled = (serviceObj: ServiceTypeRecord) => {
    return appStateObj.isEditMode ? serviceObj.enableConfigEdit : false;
  };

  const getServiceDisplayTitle = (service: ServiceTypeRecord) => {
    if (!isEmptyOrNull(service?.displayName)) {
      return service.displayName;
    }
    if (!isEmptyOrNull(service?.name)) {
      return createCamelCase(service.name);
    }
    return POLYGON_CONSTANT_TEXT.SERVICE_TYPE;
  };

  const getIsMultipleConfigurationAllowed = (serviceObj: ServiceTypeRecord): boolean => {
    const serviceProposition = servicePropositionList?.find((item: any) => item.name === serviceObj?.name);
    return PlolygonServicesUtils.isMultipleConfigurationAllowed(serviceProposition?.multiPolygonEnabled);
  };

  const handleRemovePosZoneTag = (event: any, serviceRowIndex: number, mappingListIndex: number, mappingsIndex: number, posZoneMappingArrayIndex: number) => {
    event.stopPropagation();
    setAppStateObj(prevState => {
      return produce(prevState, draft => {
        const targetPosZoneMappingArray =
          draft.serviceTypeRecordList[serviceRowIndex]
            .mappingList[mappingListIndex]
            .mappings[mappingsIndex]
            .posZoneMappingArray;

        if (isArrayValid(targetPosZoneMappingArray)) {
          targetPosZoneMappingArray?.splice(posZoneMappingArrayIndex, 1);

          if (targetPosZoneMappingArray?.length === 0) {
            draft.serviceTypeRecordList[serviceRowIndex]
              .mappingList[mappingListIndex]
              .mappings[mappingsIndex]
              .posZoneMappingArray = undefined;
          }
        }
      });
    });
  };

  const renderPosZoneMapping = (serviceObj: ServiceTypeRecord, serviceObjIndex: number, mappingObj: MappingListItem, mappingObjIndex: number, mappingsIndex: number) => {
    const isMultipleConfigurationAllowed = getIsMultipleConfigurationAllowed(serviceObj);
    if (mappingObj.isNonServiceable) {
      return <Typography className={classes.nonMappedTextStyle}>{`${"Non Serviceable Area"}`}</Typography>
    }

    if (isMultipleConfigurationAllowed && !isEmptyOrNull(mappingObj?.posZoneMappingArray)) {
      return (
        <div className={classes.multiSelectTagsContainer}>
          {mappingObj.posZoneMappingArray?.map((posZoneMapping: MappingListPosZoneArray, posZoneMappingArrayIndex: number) => (
            <div key={`${posZoneMappingArrayIndex}-${posZoneMapping?.posNo ?? ""}`} className={classes.posZoneTag}>
              <Typography className={classes.posZoneTagText}>
                {`${posZoneMapping?.posName ?? ""} (${posZoneMapping?.posNo ?? ""}) - ${posZoneMapping?.zoneName ?? ""}`}
              </Typography>
              {!isDisabled(serviceObj) && (
                <CloseIcon
                  className={classes.posZoneTagRemoveIcon}
                  onClick={(event: any) => handleRemovePosZoneTag(event, serviceObjIndex, mappingObjIndex, mappingsIndex, posZoneMappingArrayIndex)}
                />
              )}
            </div>
          ))}
          {!isDisabled(serviceObj) && (
            <Typography className={classes.addMappingTextStyle}>
              {`${POLYGON_CONSTANT_TEXT.ADD_MULTIPLE_MAPPING}`}
            </Typography>
          )}
        </div>
      )
    }

    if (!isEmptyOrNull(mappingObj.posNo)) {
      const text = `${mappingObj?.posNo ?? ""} - ${mappingObj?.posName ?? ""} - ${mappingObj?.zoneName ?? ""}`;
      return <Typography className={classes.mappedTextStyle}>{text}</Typography>;
    }
    return <Typography className={classes.addMappingTextStyle}>{`${isMultipleConfigurationAllowed ? POLYGON_CONSTANT_TEXT.ADD_MULTIPLE_MAPPING : POLYGON_CONSTANT_TEXT.ADD_MAPPING}`}</Typography>
  }

  const shouldRenderServiceAccordian = (serviceObj: ServiceTypeRecord) => {
    return !appStateObj.isEditMode || serviceObj.active
  };

  const showMultipleMappingTextBasedOnServiceName = (serviceObj: ServiceTypeRecord) => {
    const isMultipleConfigurationAllowed = getIsMultipleConfigurationAllowed(serviceObj);
    if (isMultipleConfigurationAllowed) {
      return <Typography className={classes.multipleMappingTextStyle}>{`${POLYGON_CONSTANT_TEXT.MULTIPLE_MAPPING}`}</Typography>;
    }
    return null;
  }


  const isAddOtherDaysButtonVisible = (serviceObj: ServiceTypeRecord): boolean => {
    let daysSelectedSoFar = serviceObj?.mappingList?.reduce((days: string[], value: MappingListInterface) => [...days, ...value.days], []);
    let remainingDays = ALL_DAYS_VALUES.filter((day) => !daysSelectedSoFar.includes(day));
    return remainingDays.length === 0;
  };

  const handleDaysChange = (filterType: string, serviceObjIndex: number, mappingObjIndex: number, value: string[]) => {
    setAppStateObj(prevState => {
      const newServiceTypeRecordList = prevState.serviceTypeRecordList.map((service, sIndex) => {
        if (sIndex === serviceObjIndex) {
          const newMappingList = service.mappingList.map((mapping, mIndex) => {
            if (mIndex === mappingObjIndex) {
              return { ...mapping, days: value };
            }
            return mapping;
          });
          return { ...service, mappingList: newMappingList };
        }
        return service;
      });
      return { ...prevState, serviceTypeRecordList: newServiceTypeRecordList };
    });
  };

  const onAddOtherDaysClick = (serviceObj: ServiceTypeRecord, serviceObjIndex: number) => {
    let daysSelectedSoFar = serviceObj?.mappingList?.reduce((days: string[], value: MappingListInterface) => [...days, ...value.days], []);
    let remainingDays = ALL_DAYS_VALUES.filter((day) => !daysSelectedSoFar.includes(day));
    if (!isEmptyOrNull(remainingDays)) {
      const serviceTypeRecordList = [...appStateObj.serviceTypeRecordList];
      const updatedServiceTypeRecord = { ...serviceTypeRecordList[serviceObjIndex] };
      const updatedMappingList = [...updatedServiceTypeRecord.mappingList];
      updatedMappingList.push({
        days: [],
        mappings: [
          {
            startTime: new Date().setHours(0, 0, 0),
            endTime: new Date().setHours(23, 59, 59),
            isNonServiceable: null
          }
        ]
      });
      updatedServiceTypeRecord.mappingList = [...updatedMappingList];
      serviceTypeRecordList[serviceObjIndex] = { ...updatedServiceTypeRecord };
      setAppStateObj({ ...appStateObj, serviceTypeRecordList: [...serviceTypeRecordList] });
    }
  };

  const handleRemoveOtherDays = (serviceObjIndex: number, mappingObjIndex: number) => {
    const serviceTypeRecordList = [...appStateObj.serviceTypeRecordList];
    const updatedServiceTypeRecord = { ...serviceTypeRecordList[serviceObjIndex] };
    const updatedMappingList = [...updatedServiceTypeRecord.mappingList];
    updatedMappingList.splice(mappingObjIndex, 1);
    updatedServiceTypeRecord.mappingList = [...updatedMappingList];
    serviceTypeRecordList[serviceObjIndex] = { ...updatedServiceTypeRecord };
    setAppStateObj({ ...appStateObj, serviceTypeRecordList: [...serviceTypeRecordList] });
  };

  useEffect(() => {
    !isEmptyOrNull(posZoneMapListService?.error) && configurePosZoneDataError();
  }, [posZoneMapListService, posZoneMapListService.error]);

  useEffect(() => {
    // Fire on SUCCEEDED so an empty array (200 with no content) also turns the loader off
    // and opens the dialog, instead of getting filtered out by isEmptyOrNull([]) === true.
    if (posZoneMapListService?.fetchStatus === API_RESPONSE_STATUS.SUCCEEDED) {
      configurePosZoneData();
    }
  }, [posZoneMapListService?.fetchStatus, posZoneMapListService?.data]);

  useEffect(() => {
    !isEmptyOrNull(allPolygonListIdsRecord?.error) && configurePolygonIdsRecordError();
  }, [allPolygonListIdsRecord, allPolygonListIdsRecord.error]);

  useEffect(() => {
    !isEmptyOrNull(allPolygonListIdsRecord?.data) && configurePolygonIdsRecord();
  }, [allPolygonListIdsRecord, allPolygonListIdsRecord.data]);

  useEffect(() => {
    const query: any = new URLSearchParams(location.search);
    let polygonId = query.get(POLYGON_CONSTANT_TEXT.POLYGON_ID_PARAM);
    if (!isUndefined(polygonId) && !isEmptyOrNull(polygonId)) {
      getPolygonIdDetails(polygonId);
    } else {
      getAllPolygonRecords();
    }
  }, [location.search]);

  useEffect(() => {
    return () => {
      appDispatch(PlolygonServicesSlice.resetAllPolygonIdsRecordServiceState());
      appDispatch(PlolygonServicesSlice.resetSpecificPolygonIdDetailsState());
    };
  }, []);

  const renderServiceAccordian = (serviceObj: ServiceTypeRecord, serviceObjIndex: number) => {
    const isMultipleConfigurationAllowed = getIsMultipleConfigurationAllowed(serviceObj);
    const showAddData = serviceObj.active && !isDisabled(serviceObj);
    const renderAddOtherDaysButton = isAddOtherDaysButtonVisible(serviceObj);

    return (
      <Accordion
        key={`${serviceObjIndex}-${serviceObj?.name}-serviceObj-service-type-record-list`}
        className={classes.accordionStyle}
        expanded={serviceObj.openAccordian}
        onChange={(event) => handleServiceTypeAccordionOpenState(event, serviceObjIndex)}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummaryStyle}>
          <Grid container justifyContent="space-between" spacing={0}>
            <Grid item xs={4} className={classes.marginAuto}>
              <Typography className={classes.accordionTitle}>{`${getServiceDisplayTitle(serviceObj)}`}</Typography>
            </Grid>
            <Grid item xs={8} className={classes.marginAuto}>
              <ChangeConfigOtion
                is_edit_mode={appStateObj.isEditMode}
                classes={classes}
                use_existing_checked={serviceObj.sameAsEarlier}
                use_existing_config_change_handler={(e: any) => existingConfigChangeHandler(e, serviceObjIndex, "sameAsEarlier")}
                change_existing_checked={serviceObj.enableConfigEdit}
                use_change_existing_config_change_handler={(e: any) => configChangeExistingHandler(e, serviceObjIndex, "enableConfigEdit")}
              />
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetailsStyle}>
          {showMultipleMappingTextBasedOnServiceName(serviceObj)}
          {serviceObj.active && (
            <div className={classes.configurationDivStyle}>
              {serviceObj?.mappingList?.map((mappingObj: MappingListInterface, mappingObjIndex: number) => (
                <Box className={classes.mappingContainerBoxStyle}>
                  <Grid container spacing={1} key={`mapping-${mappingObjIndex}-${mappingObj.days}`} justifyContent="space-between" className={classes.daysFilterContainer}>
                    <Grid item xs={4}>
                      <MultiSelectBox
                        fieldLabel=""
                        menuitems={PlolygonServicesUtils.calculateAvailableDaysForSelection(mappingObjIndex, serviceObj.mappingList)}
                        value={mappingObj.days}
                        onChange={(e: any) => handleDaysChange(POLYGON_CONSTANT_TEXT.DAY_FILTER, serviceObjIndex, mappingObjIndex, e)}
                        disabled={appStateObj.isEditMode ? serviceObj.enableConfigEdit : false}
                        doNotShowAllInAllSelected={true}
                      />
                    </Grid>
                    <Grid item>
                      {mappingObjIndex === 0 ?
                        showAddData &&
                        <LinkButton
                          buttonLabel={`${POLYGON_CONSTANT_TEXT.ADD_OTHER_DAYS}`}
                          disabled={renderAddOtherDaysButton}
                          onClick={() => onAddOtherDaysClick(serviceObj, serviceObjIndex)}
                        />
                        : showAddData && <DeleteIcon className={classes.deleteIconStyle} onClick={() => handleRemoveOtherDays(serviceObjIndex, mappingObjIndex)} />
                      }
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} className={classes.headingFilterContainer}>
                    <Grid item className={classes.configrationGridItemStyle}>
                      <Typography className={classes.configurationHeaderTextStyle}>{POLYGON_CONSTANT_TEXT.START_TIME}</Typography>
                    </Grid>
                    <Grid item className={classes.configrationGridItemStyle}>
                      <Typography className={classes.configurationHeaderTextStyle}>{POLYGON_CONSTANT_TEXT.END_TIME}</Typography>
                    </Grid>
                    <Grid item className={classes.configrationGridItemStyle}>
                      <Typography className={classes.configurationHeaderTextStyle}>{POLYGON_CONSTANT_TEXT.POS_ZONE}</Typography>
                    </Grid>
                    {showAddData &&
                      <LinkButton
                        buttonLabel={`${POLYGON_CONSTANT_TEXT.ADD_NEW_SLOT}`}
                        disabled={false}
                        onClick={() => handleAddMappingButton(serviceObjIndex, mappingObjIndex)}
                      />
                    }
                  </Grid>
                  {mappingObj?.mappings?.map((mappings: MappingListItem, mappingsIndex: number) => (
                    <Grid item key={`${mappingObjIndex}-${mappingsIndex}-${mappings?.startTime}-service`}>
                      <Grid container spacing={1} className={classes.configurationValueDivStyle}>
                        <Grid item className={isMultipleConfigurationAllowed ? classes.marginNone : classes.configrationGridItemStyle}>
                          <TimePicker
                            value={mappings.startTime}
                            name={"startTime"}
                            handleChange={(date: any) => handleServiceTimeChange(mappingsIndex, mappingObjIndex, serviceObjIndex, "startTime", date)}
                            disabled={appStateObj.isEditMode ? serviceObj.enableConfigEdit : false}
                          />
                        </Grid>
                        <Grid item className={isMultipleConfigurationAllowed ? classes.marginNone : classes.configrationGridItemStyle}>
                          <TimePicker
                            value={mappings.endTime}
                            name={"endTime"}
                            handleChange={(date: any) => handleServiceTimeChange(mappingsIndex, mappingObjIndex, serviceObjIndex, "endTime", date)}
                            disabled={appStateObj.isEditMode ? serviceObj.enableConfigEdit : false}
                          />
                        </Grid>
                        <Grid
                          item
                          className={isDisabled(serviceObj) ? classes.disabledSectionContainer : classes.sectionContainer}
                          onClick={() => (isDisabled(serviceObj) ? undefined : handleOpenPosZoneMappingDialog(serviceObj?.name, serviceObjIndex, mappingObjIndex, mappingsIndex))}
                        >
                          {renderPosZoneMapping(serviceObj, serviceObjIndex, mappings, mappingObjIndex, mappingsIndex)}
                        </Grid>
                        {!isDisabled(serviceObj) && mappingsIndex !== 0 && (
                          <Grid item className={classes.deleteSectionContainer}>
                            <DeleteIcon
                              className={classes.deleteIconStyle}
                              onClick={() => (isDisabled(serviceObj) ? undefined : handleRemoveMappingButton(serviceObjIndex, mappingObjIndex, mappingsIndex))}
                            />
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  ))}
                </Box>
              ))}
            </div>
          )}
        </AccordionDetails>
      </Accordion>
    );
  };

  return (
    <>
      <OverlayLoader loading={appStateObj.loading} />
      <div className={classes.container}>
        <Grid container justifyContent="space-between">
          <Grid item xs={12}>
            <Typography className={classes.heading}>
              {`
              ${appStateObj.isEditMode
                  ? POLYGON_CONSTANT_TEXT.UPDATE_CONFIGURATION
                  : POLYGON_CONSTANT_TEXT.CREATE_NEW_CONFIGURATION_BUTTON
                }
              ${!isEmptyOrNull(appStateObj.polygonId)
                  ? "Polygon ID : " + appStateObj.polygonId
                  : ""
                }`}
            </Typography>
          </Grid>
        </Grid>
        <Grid className={classes.configDetailsDiv}>
          <>
            {appStateObj.serviceTypeRecordList.map((serviceObj: ServiceTypeRecord, serviceObjIndex: number) =>
              shouldRenderServiceAccordian(serviceObj) ? renderServiceAccordian(serviceObj, serviceObjIndex) : null
            )}
            {!appStateObj.isEditMode && (
              <RenderPolygonIdsMapping
                classes={classes}
                totalPolygonIds={allPolygonListIdsRecord?.data?.length || 0}
                mappedPolygonIdsRecord={appStateObj.mappedPolygonIdsRecord}
                polygonIdsSearchTextValue={appStateObj.polygonIdsSearchTextValue}
                mappedPolygonIdsSearchTextValue={appStateObj.mappedPolygonIdsSearchTextValue}
                getPolygonDetails={getPolygonDetails}
                headerPolygonIdsRowCheckboxOnchange={headerPolygonIdsRowCheckboxOnchange}
                tableRowCellCheckboxOnchange={tableRowCellCheckboxOnchange}
                handlePolygonIdSearchTextChange={handlePolygonIdSearchTextChange}
                handleMappedPolygonIdSearchTextChange={handleMappedPolygonIdSearchTextChange}
                deleteSelectedMappedPolygonId={deleteSelectedMappedPolygonId}
                getPolygonIdsRecordList={getPolygonIdsRecordList}
                getMappedPolygonIdsRecordList={getMappedPolygonIdsRecordList}
              />
            )}
            <Grid className={classes.configButtonDiv}>
              <Link to={{ pathname: `${APP_ROUTES.POLYGON_SERVICES}` }} style={{ textDecoration: "none" }}>
                <PrimaryButton className={classes.cancelConfigStyle} buttonLabel={`${POLYGON_CONSTANT_TEXT.BACK_TO_LIST}`} disableFocusRipple={true} disableRipple={true} />
              </Link>
              {appStateObj.isEditMode ? (
                <PrimaryButton className={classes.previewAndUpdateConfigStyle} buttonLabel={`Update`} disableFocusRipple={true} disableRipple={true} onClick={() => handlePolygonConfigurationUpdate()} />
              ) : (
                <PrimaryButton className={classes.previewAndUpdateConfigStyle} buttonLabel="Save" disableFocusRipple={true} disableRipple={true} onClick={() => handlePolygonConfigurationSave()} />
              )}
            </Grid>
          </>
        </Grid>
        {appStateObj.showPosZoneMappingPopUp && (
          <PosZoneMappingDialog
            open={appStateObj.showPosZoneMappingPopUp}
            handleClose={handleClosePosZoneMappingDialog}
            stateObj={appStateObj}
            fetchRecordsByPosCode={fetchRecordsByPosCode}
            handleKeyUp={handleKeyUp}
            handlePosZoneSearchChange={handlePosZoneSearchChange}
            updatePosNumberOpenIndex={updatePosNumberOpenIndex}
            handleChangeIsNonServiceable={handleChangeIsNonServiceable}
            selectPosZoneForMapping={selectPosZoneForMapping}
            handlePOSZoneMappingSubmit={handlePOSZoneMappingSubmit}
            currentCountry={currentCountry}
            isLoading={appStateObj.loading}
            servicePropositionList={servicePropositionList}
          />
        )}
        {appStateObj.openPolygonDetailsPopUp && (
          <RenderPolygonDetailsPopUp
            open={appStateObj.openPolygonDetailsPopUp}
            handleClose={handleClosePolygonDetailsPopUp}
            polygonDetailsPopUpData={appStateObj.polygonDetailsPopUpData}
            polygonServiceRecord={PlolygonServicesUtils.generateServiceNameValueForPolygon(servicePropositionList, userInfo)}
          />
        )}
      </div>
    </>
  );
};

export default React.memo(PlolygonServicesConfigurationPage);
